<script setup lang="ts">
import { VETBOT_PROMO_CODE, vetbotUrl } from '~~/shared/utils/vetbot'

const props = withDefaults(defineProps<{
  campaign: string
  compact?: boolean
}>(), {
  compact: false,
})

const { capture } = useAnalytics()
const copied = ref(false)

const href = computed(() => vetbotUrl(props.campaign))

async function copyCode() {
  try {
    await navigator.clipboard.writeText(VETBOT_PROMO_CODE)
    copied.value = true
    capture('vetbot_promo_code_copied', { surface: props.campaign })
    setTimeout(() => { copied.value = false }, 2000)
  } catch {
    // Clipboard unavailable — code is still visible for manual copy
  }
}

function onLinkClick() {
  capture('vetbot_promo_clicked', { surface: props.campaign })
}
</script>

<template>
  <div
    class="rounded-xl border-2 border-primary/20 bg-primary/5 p-4 sm:p-5"
    :class="compact ? '' : 'space-y-3'"
  >
    <div class="flex items-start gap-3">
      <div class="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
        <UIcon name="i-lucide-phone-call" class="w-5 h-5 text-primary" />
      </div>
      <div class="flex-1 min-w-0 space-y-1">
        <p class="font-semibold text-highlighted">
          Ať vám neuteče žádný hovor od klienta
        </p>
        <p class="text-sm text-muted">
          Vetbot je AI recepční, která za vaši ordinaci zvedá telefony a odpovídá na dotazy — i po ordinační době.
          Jako klinika z našeho katalogu máte <strong>10% slevu na první 3 měsíce</strong>.
        </p>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row sm:items-center gap-3" :class="compact ? 'mt-3' : ''">
      <button
        type="button"
        class="flex items-center gap-2 px-3 py-2 rounded-lg border border-dashed border-primary/40 bg-white dark:bg-primary-950/40 font-mono text-sm font-semibold text-primary hover:bg-primary/5 transition-colors cursor-pointer"
        @click="copyCode"
      >
        <UIcon :name="copied ? 'i-lucide-check' : 'i-lucide-copy'" class="w-4 h-4" />
        {{ VETBOT_PROMO_CODE }}
        <span class="text-xs text-dimmed font-sans font-normal">{{ copied ? 'zkopírováno' : 'kopírovat' }}</span>
      </button>

      <a
        :href="href"
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
        @click="onLinkClick"
      >
        Prohlédnout ukázky
        <UIcon name="i-lucide-arrow-right" class="w-4 h-4" />
      </a>
    </div>
  </div>
</template>
